import React from "react";
import { BasicTabs, CardWithActions, LineDivider } from "@/components";
import LeaveApplication from "@/pages/attendanceManagement/monthEndProcess/LeaveApplication";
import AdminAttendanceRegularize from "@/pages/attendanceManagement/monthEndProcess/AttendanceRegularization";
import CardContent from "@/pages/attendanceManagement/components/CardContent";

function MonthEndProcess() {
  return (
    <CardContent title={"Month End Process"}>
      <BasicTabs
        tabs={[
          {
            label: "Leave Application",
            component: <LeaveApplication />,
          },
          {
            label: "Attendance Regularization",
            component: <AdminAttendanceRegularize />,
          },
        ]}
      /></CardContent>
  );
}

export default MonthEndProcess;
